<template>
  <div class="emergency-professor">
    <Card>
      <Card :dis-hover="true" :bordered="false" :padding="10" style="text-align: right">
        <!--      <Button type="primary" size="small" style="margin-left: 8px">重置</Button>-->
        <Button code="emergency.professor.add" type="primary" @click="gotoAdd" style="margin-left: 4px">新增</Button>
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">导入</Button>-->
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">导出</Button>-->
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">模版下载</Button>-->
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">批量删除</Button>-->
        <!--      <Button type="primary" @click="" disabled style="margin-left: 4px">批量维护</Button>-->
      </Card>
      <Card :dis-hover="true" :bordered="false" :padding="0">
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="级别" :label-style="{'text-align': 'right', 'width':'120px'}">
            <RadioGroup size="small" v-model="level" type="button" @on-change="tagChange">
              <Radio :label="0">全部</Radio>
              <Radio :label="1">国家级专家</Radio>
              <Radio :label="2">省级专家</Radio>
              <Radio :label="3">市级专家</Radio>
              <Radio :label="4">县区级专家</Radio>
            </RadioGroup>
          </el-descriptions-item>
          <!--        <el-descriptions-item label="是否上传照片" :label-style="{'text-align': 'right'}">-->
          <!--          <RadioGroup size="small" v-model="isUpPhoto" type="button" @on-change="tagChange">-->
          <!--            <Radio :label="0">全部</Radio>-->
          <!--            <Radio :label="1">是</Radio>-->
          <!--            <Radio :label="2">否</Radio>-->
          <!--          </RadioGroup>-->
          <!--        </el-descriptions-item>-->
          <el-descriptions-item label="行政区划" :label-style="{'text-align': 'right'}">
            <Row>
              <Col :span="6">
                <span>专家姓名：</span>
                <Input clearable v-model="proName" style="width:180px"></Input>
              </Col>
              <!--            <Col :span="6">-->
              <!--              <span>年龄：</span>-->
              <!--              <Input v-model="proName" style="width:100px" ></Input>-->
              <!--              ～-->
              <!--              <Input v-model="proName" style="width:100px" ></Input>-->
              <!--            </Col>-->
              <Col :span="7">
                <span>专业类别：</span>
                <TreeSelect class="treeSelect" transfer clearable v-model="professionType"
                            :data="expertiseList"/>
              </Col>
              <Col :span="5">
                <span>区县：</span>
                <Select transfer v-model="country" :disabled="countryList.length === 1" clearable style="width:150px">
                  <Option v-for="(item) in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}</Option>
                </Select>
              </Col>
              <Col :span="5">
                <Button type="primary" @click="getEmergencyPro">查询</Button>
              </Col>
            </Row>
          </el-descriptions-item>
        </el-descriptions>
        <!--      <div style="text-align: center;margin-top: 10px">-->
        <!--        <Button type="primary" size="small">查询</Button>-->
        <!--        <Button type="primary" size="small" style="margin-left: 8px">重置</Button>-->
        <!--      </div>-->
      </Card>
      <Row :gutter="4" style="margin-top: 10px">
        <Col :span="24">
          <Card :dis-hover="true" :padding="4" :bordered="false">
            <Table
                :loading="dataLoading"
                :columns="columns"
                :data="data"
                :border="false"
                :stripe="false"
                :highlight-current-row="true"
            >
              <template #action="{ row, index }">
                <!--              <el-button size="small" type="text" disabled >定位</el-button>-->
                <!--              <el-button size="small" type="text" @click="gotoDetail(row)">查看</el-button>-->
                <!--              <el-button size="small" type="text" @click="gotoHistory(row)" disabled>调派历史</el-button>-->
                <!--              <el-button size="small" type="text" @click="gotoSend(row)" disabled>调派</el-button>-->
                <el-button size="small" type="text" :disabled="row.specialist.createUser !== curUserId"
                           @click="editPro(row)">编辑
                </el-button>
                <el-button size="small" type="text" :disabled="row.specialist.createUser !== curUserId"
                           @click="deletePro(row)">删除
                </el-button>
              </template>
            </Table>
            <Page style="text-align: right;margin-top: 10px"
                  show-sizer
                  show-total
                  transfer
                  :total="dataTotal"
                  :page-size="pageSize"
                  :page-size-opts="pageSizeOpts"
                  :current-page="currentPage"
                  @on-change="pageChange"
                  @on-page-size-change="pageSizeChange"
            ></Page>
          </Card>
        </Col>
        <!--      <Col :span="9">-->
        <!--        <Card :dis-hover="true" :padding="0">-->
        <!--          <img src="../../../assets/Map.png" height="100%" width="100%"/>-->
        <!--        </Card>-->
        <!--      </Col>-->
      </Row>
    </Card>
  </div>
</template>

<script>
export default {
  name: "emergencyProfessor",
  data() {
    return {
      proName: '',
      professionType: '',
      expertiseList: [],
      country: '',
      countryList: [],
      level: 0,
      isUpPhoto: 0,
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '姓名',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.specialist.name)
          }
        },
        // {
        //   title: '年龄',
        //   align: 'center',
        //   // width: '130',
        //   render: (h, params) => {
        //     return h('div', {
        //       style: {
        //         textAlign: 'left'
        //       }
        //     }, params.row.specialist.personInCharge)
        //   },
        // },
        {
          title: '行政区划',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, `${params.row.areaName}-${params.row.streedName}`)
          }
        },
        {
          title: '专家级别',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.levelName)
          }
        },
        {
          title: '适用事件类型',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.eventName)
          }
        },
        {
          title: '维护时间',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.specialist.updateTime === null ? '' : this.$moment(params.row.specialist.updateTime).format('YYYY-MM-DD HH:mm'))
          }
        },
        {
          width: '160',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action'
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      curUserId: ''
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          console.log(newVal)
          this.curUserId = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        console.log(this.$store)
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    this.getEmergencyPro()
    this.getExpertise()
    this.getCountry()
  },
  methods: {
    gotoAdd() {
      this.$router.push({
        name: 'addEmProfessor'
      })
    },
    editPro(row) {
      this.$router.push({
        name: 'addEmProfessor',
        params: {
          row: row
        }
      })
    },
    deletePro(row) {
      let idList = []
      idList.push(parseInt(row.specialist.id))
      this.$http.post(`/api/specialist/delete`, idList).then(res => {
        this.getEmergencyPro()
      })
    },
    gotoDetail(row) {
      this.$router.push({
        name: 'emProfressorDetail',
        params: {
          row: row
        }
      })
    },
    gotoSend(row) {
      this.$router.push({
        name: 'sendProfressor',
        params: {
          row: row
        }
      })
    },
    gotoHistory(row) {
      this.$router.push({
        name: 'sendProHistory',
        params: {
          row: row
        }
      })
    },
    //区县
    getCountry() {
      this.$http.get('/api/getLowerLevelDepts?flag=4').then(res => {
        console.log(res)
        this.countryList = res.data
        if (this.countryList.length === 1) {
          this.country = res.data[0].indexCode
        }
      })
    },
    //根据区县获取街道
    getStreet() {
      this.$http.get(`/api/street/${1}`).then(res => {
        console.log(res)
      })
    },
    //获取专业类型/api/expertise/getAll
    getExpertise() {
      this.$http.get('/api/expertise/getAll').then(res => {
        console.log(res)
        this.expertiseList = res.data.data
        console.log(this.expertiseList)
      })
    },
    //
    getEmergencyPro() {
      this.dataLoading = true
      let params = {
        specialistLevel: this.level === 0 ? '' : this.level,
        name: this.proName,
        professionType: this.professionType,
        responsibleAreaId: this.country
      }
      this.$http.post(`/api/specialist/getAll?page=${this.currentPage}&&size=${this.pageSize}`, params).then(res => {
        console.log(res)
        this.data = res.data.data.list
        this.dataTotal = res.data.data.total
        this.dataLoading = false
      })
    },
    tagChange(value) {
      console.log(value)
      this.getEmergencyPro()
    },
    pageChange(page) {
      this.currentPage = page
      this.getEmergencyPro()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getEmergencyPro()
    }
  }
}
</script>

<style scoped lang="less">
.emergency-professor {
  .ivu-radio-group-item {
    margin-left: 16px;
  }

  .treeSelect {
    width: 200px;
  }
}
</style>
